 <div>
  <app-nav *ngIf="navVisible"></app-nav>
  <router-outlet (activate)="onActivate($event)"></router-outlet>
</div>
